import { FieldsTable as AntdFieldsTable } from "@empglabs/backoffice-ui-kit"

const FieldsTable = props => {
  return <AntdFieldsTable {...props} />
}

export default FieldsTable
